import React, { FC } from 'react';
import { usePublicFeedbackState } from '../../../providers/PublicFeedback';
import { translations } from '../strings';
import modalStyles from '../ModalLayout/index.module.css';
import logoMini from '../assets/logo-mini.png';

type Props = {};

const PoweredBy: FC<Props> = () => {
  const { locale } = usePublicFeedbackState();
  const strings = translations(locale);
  return (
    <div className={modalStyles.footer}>
      {strings.powered_by}{' '}
      <a
        href="https://bugherd.com/?utm_source=public&utm_medium=widget"
        target="_blank"
      >
        <img src={logoMini} alt="BugHerd logo" />
      </a>
    </div>
  );
};

export default PoweredBy;
